// Centralized API configuration for the entire application
// When opened on localhost, always use the local backend (port 5678).
// Set FORCE_PRODUCTION_API = true only if you intentionally test localhost UI against live API.
const FORCE_PRODUCTION_API = false;

const isBrowserLocalhost = () => {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
};

const IS_DEVELOPMENT = !FORCE_PRODUCTION_API && (
  process.env.NODE_ENV === "development" || isBrowserLocalhost()
);

const getApiUrl = () => {
  if (IS_DEVELOPMENT) {
    return "http://localhost:5678/api";
  }
  return "https://api.panthersecure.co.in/api";
};

const getServerUrl = () => {
  if (IS_DEVELOPMENT) {
    return "http://localhost:5678";
  } else {
    return "https://api.panthersecure.co.in";
  }
};

const getImageUrl = () => {
  if (IS_DEVELOPMENT) {
    return "http://localhost:5678/static";
  } else {
    return "https://api.panthersecure.co.in/static";
  }
};

const getSocketUrl = () => {
  if (IS_DEVELOPMENT) {
    return "http://localhost:5678";
  } else {
    return "https://api.panthersecure.co.in";
  }
};

// Log the configuration for debugging
console.log('🔧 API Configuration:', {
  mode: IS_DEVELOPMENT ? 'DEVELOPMENT' : 'PRODUCTION',
  API_URL: getApiUrl(),
  SERVER_URL: getServerUrl(),
  IMAGE_URL: getImageUrl(),
  SOCKET_URL: getSocketUrl()
});

export {
  IS_DEVELOPMENT,
  getApiUrl,
  getServerUrl,
  getImageUrl,
  getSocketUrl
};
